// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AbstractState from '../../animationpack/state/AbstractState';

/**
 * A "steady" state is an animation state that is concrete and stand-alone (vs. a state that handles transitioning between two states, for example.)
 */
class SteadyState extends AbstractState {
  
  /**
   * @param {string} name Name of state
   */
  constructor(name) {
    super();

    this.id = null;
    this._name = name;
    this._transitions = {};
    this._sourceTree = null;
  }

  /**
   * Sets the clipsource of the steadystate
   * @param {(ClipSource|BinaryLerpSource|FrozenClipSource|ManagedTransformSource)} clipSource
   */
  setClipSource(clipSource) {
    this._sourceTree = clipSource;
  }

  /*
   * Updates the states clip instances
   */
  update(globalTime) {
    if (this._sourceTree && !this._sourceTree.setTime(globalTime)) {
      if (this.onFinished) {
        this.onFinished();
      }
    }
  }

  /*
   * Gets the current animation data, used in {@link AnimationLayer}
   */
  getCurrentSourceData() {
    return this._sourceTree ? this._sourceTree.getSourceData() : null;
  }

  /*
   */
  getCurrentLoop() {
    return this._sourceTree ? this._sourceTree.currentLoop : null;
  }

  /*
   * Resets the animationclips in the sourcetree
   * @param {number} globalStartTime Usually current time
   */
  resetClips(globalStartTime) {
    super.resetClips(globalStartTime);
    if(this._sourceTree) {
      this._sourceTree.resetClips(globalStartTime);
    }
  }

  shiftClipTime(shiftTime) {
    super.shiftClipTime(shiftTime);
    if (this._sourceTree) {
      this._sourceTree.shiftClipTime(shiftTime);
    }
  }

  setTimeScale(timeScale) {
    if (this._sourceTree) {
      this._sourceTree.setTimeScale(timeScale);
    }
  }

  clone() {
    const cloned = new SteadyState(this._name);

    for (const key in this._transitions) {
      cloned._transitions[key] = this._transitions[key];
    }

    cloned._sourceTree = this._sourceTree ? this._sourceTree.clone() : null;

    return cloned;
  }
}

export default SteadyState;
